// extracted by mini-css-extract-plugin
export default {"CommercialsSectionContainer":"CommercialsSection_CommercialsSectionContainer__5xFYy"};